export const FLEXIBLE_PORTAL_CONSTANTS = {
  ROUTES: {
    MAIN: 'foodback-portal',
  },
};
